import { createContext, useState } from "react";

export const AwardsContext = createContext();